/**
 * Attempt to copy a specific custom element from one registry to another.
 */
export function syncCustomElementRegistries(tagName, originRegistry, destRegistry) {
    if (!tagName || !originRegistry || !destRegistry)
        return;
    const elementConstructor = originRegistry.get(tagName);
    if (destRegistry.get(tagName) || !elementConstructor) {
        // Do nothing if the element is already defined in the destination registry,
        // or if the element is not defined in the origin registry.
        return;
    }
    destRegistry.define(tagName, elementConstructor);
}
